import { Enums } from '@bode-canada/core';
import type { PageDto } from '@bode-canada/core/interfaces';
import ServerlessApiService from '../ServerlessApiService';
import { GetAdminOfferManagementDto } from '@/types/offer-management';

const { ServerlessApiPathEnum, ProMarketplaceApiPathEnum } = Enums;

export default class ProMarketplaceApiService {
  static BASE_URL = `${ProMarketplaceApiPathEnum.PRO_MARKETPLACE}/${ServerlessApiPathEnum.V1}`;

  static updateListingServiceRequestStatus(
    listingId: number,
    status: Enums.ServiceRequestStatus,
    cancellationReason?: string,
  ): Promise<PageDto<GetAdminOfferManagementDto>> {
    return ServerlessApiService.put(
      `${this.BASE_URL}/${ProMarketplaceApiPathEnum.UPDATE_STATUS}/${listingId}`,
      {
        cancellationReason: cancellationReason || '',
        status,
      },
    );
  }
}
